import { render } from "./MenuMediasTableMediafiles.vue?vue&type=template&id=13fd8518"
import script from "./MenuMediasTableMediafiles.vue?vue&type=script&lang=js"
export * from "./MenuMediasTableMediafiles.vue?vue&type=script&lang=js"

import "./MenuMediasTableMediafiles.vue?vue&type=style&index=0&id=13fd8518&lang=css"
script.render = render

export default script